/* eslint-disable react/prop-types */
const LabelDropdown = ({ label, options, defaultValue }) => {
  return (
    <div className="flex items-center justify-between gap-6">
      <h4 className="text-[#EEEEEE] font-light text-lg">{label}: </h4>
      <select className="px-2 py-1 bg-black text-white font-light border-[1px] border-gray-600 rounded w-[60%]">
        <option value="">{defaultValue}</option>
        {options.map((option, index) => (
          <option key={index} value={option.toLowerCase()}>
            {option}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LabelDropdown;
